import { CountUp } from 'countup.js';
import $ from 'jquery';

function counter() {
    $.fn.isInViewport = function() {
        return window.scrollY + window.innerHeight - 300 > $('.countContainer').offset().top;
    };
    
    function countUp(goal, el) {
            const options = {
              duration: 6,
              decimal: false,
              separator: ''
            };
    
            let count = new CountUp(el, goal, options);
    
            if (!count.error) {
              count.start();
            } else {
              console.error(count.error);
            }
    }
    
    const goals = [];
    let hasRun = false;
    
    $('.countNum').each(function(i){
        goals.push(Number(this.innerHTML));
        $(this).html(0);
    });
    
    if($('.countContainer').isInViewport() && !hasRun) {
        setTimeout(() => {
            $('.countNum').each(function(i){
                countUp(goals[i], this);
            });
        }, 500);
    
        hasRun = true;
    }
    
    $(window).on('resize scroll', e => {
        if($('.countContainer').isInViewport() && !hasRun) {
            setTimeout(() => {
                $('.countNum').each(function(i){
                    countUp(goals[i], this);
                });
            }, 250);
    
            hasRun = true;
        }
    });    

    // If IE11
    const isIE = /*@cc_on!@*/false || !!document.documentMode;

    if(isIE) {
        $('.countNum').each(function(i){
            countUp(goals[i], this);
        });
    }
}

$(document).ready(() => {
    if($('.countContainer').length) {
        counter();
    }
});